import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import { List } from '@beisen/chaos-ui';
import ComponentHolder from '../Common/ComponentHolder';
import * as helper from '../util/helper';
import * as urlHelper from '../util/url';
import * as uiHelper from '../util/ui';
import * as linkUrl from '../util/linkUrlJsonString';
import MemoryManager from '../util/memoryManager';
import TableList from '../Table_Components/TableList/TableList';
import * as stateUtil from '../util/componetState';

export default class FormList extends Component {
    constructor(props, context) {
        super(props, context);
        this.tableItemClick = this.tableItemClick.bind(this);
        MemoryManager.setItemBeforeUnload(
            location.href,
            this.getCurrentVisbileItem.bind(this),
            'local'
        );
        this.rememberPostion = JSON.parse(MemoryManager.getItem(location.href));
    }
    componentDidUpdate() {
        if (this.rememberPostion) {
            this.getScrollParent().scrollTop = this.rememberPostion.scrollTop;
            this.clearMemory();
        }
    }
    clearMemory() {
        this.rememberPostion = null;
        MemoryManager.removeItem(location.href);
    }
    getScrollParent() {
        this._scrollParent =
            this._scrollParent ||
            uiHelper.getScrollParent(ReactDOM.findDOMNode(this.refs.formlist));
        return this._scrollParent;
    }
    getScrollTop() {
        return uiHelper.getScrollTop(this.getScrollParent());
    }
    getCurrentVisbileItem() {
        const scrollTop = this.getScrollTop();
        return { scrollTop: scrollTop };
    }
    tableItemClick(e, item) {
        if (this.props.onTableItemClick) {
            this.props.onTableItemClick(e, item);
            return null;
        }
        let dataItem = Object.assign({}, item); //此处需要将形参item转换一下再去修改，因为item read only
        for (let key in dataItem) {
            if (typeof dataItem[key] === 'object' && dataItem[key] != null) {
                dataItem[key] = dataItem[key]['value'];
            }
        }
        const linkUrlString =
            dataItem.linkUrl && linkUrl.linkUrlJsonString(dataItem.linkUrl);
        let redirectUrl =
            linkUrlString &&
            urlHelper.formatUrl(
                linkUrlString.url || linkUrlString,
                this.props.querUrl,
                this.props.cmpContext,
                [dataItem]
            );
        if (redirectUrl) {
            if (redirectUrl.indexOf('?') > -1) {
                redirectUrl = redirectUrl + '&fromURL=homedetail';
            } else {
                redirectUrl = redirectUrl + '?fromURL=homedetail';
            }
            helper.pageJump(redirectUrl, {
                openModel: dataItem.OpenTarget || '',
                hasShadowContext:
                    typeof linkUrlString.hasShadowContext !== 'undefined'
                        ? linkUrlString.hasShadowContext
                        : true
            });
        }
    }
    //根据TableList元数据生成基础组件需要的数据
    getBasicComponentNeededDataList() {
        let selectIds = this.props.selectIds;
        let showColumn = this.props.showColumn;
        const rowsLimit = this.props.rowsLimit;
        let datalist = [];
        if (
            this.props.biz_data.length == 0 &&
            this.props.cmp_data.paging &&
            this.props.cmp_data.paging.page == 0
        ) {
            datalist = [];
        } else {
            let cloneData = Object.assign(this.props.biz_data);
            if (rowsLimit) {
                if (this.props.biz_data.length > rowsLimit) {
                    cloneData = this.props.biz_data.slice(0, rowsLimit);
                }
            }
            datalist = [];
            cloneData.forEach((row, rowIndex) => {
                let item = {
                    showChecked: this.props.showChecked || false,
                    mainInfo: {},
                    subInfo: []
                };
                this.props.selectIds &&
                this.props.selectIds.indexOf(row['_id'].value) >= 0
                    ? (item.checked = true)
                    : (item.checked = false);
                let colIndex = 0;
                this.props.sub_cmps.forEach((col, index) => {
                    let cellItem = row[col.cmp_data.field_name];
                    item[col.cmp_data.field_name] = cellItem;
                    if (!cellItem) {
                        cellItem = {};
                    }
                    let avatar =
                        cellItem.avatars && cellItem.avatars[cellItem.value];
                    if (
                        ['SingleStaffInput', 'MultiStaffInput'].indexOf(
                            col.cmp_data.controlPack
                        ) != -1
                    ) {
                        cellItem.text = uiHelper.extractUserName(cellItem.text);
                    }
                    let context = {
                            metaObjName:
                                this.props.cmp_data.metaObjName ||
                                this.props.cmp_data.metaObjectName,
                            viewName: this.props.cmp_data.viewName
                        },
                        data = [
                            {
                                _id: row['_id'].value
                            }
                        ];
                    if (col.cmp_data.isLink && !item.linkUrl) {
                        item.linkUrl =
                            col.cmp_data.linkURL ||
                            helper.getAPI('TableColLinkTemp');
                        item.OpenTarget = col.cmp_data.OpenMode;
                    }
                    if (!stateUtil.isInvisible(col.cmp_data)) {
                        if (col.cmp_data.frozen && colIndex == 0) {
                            item.mainInfo.title = uiHelper.extractUserName(
                                cellItem.text
                            );
                            if (
                                col.cmp_data.controlPack == 'SingleStaffInput'
                            ) {
                                item.mainInfo.Name =
                                    uiHelper.extractUserName(cellItem.text) ||
                                    '----';
                                item.mainInfo.showMedia = true;
                                if (avatar) {
                                    item.mainInfo.avatars = avatar;
                                } else {
                                    item.mainInfo.mediaType = 'default';
                                }
                            }
                        } else if (col.cmp_data.frozen && colIndex == 1) {
                            item.mainInfo.subTitle = cellItem.text;
                        } else {
                            let subItem = {
                                title: col.cmp_data.title
                            };
                            subItem.ControlType = col.cmp_data.controlPack;
                            subItem.value = cellItem.value;
                            if (avatar) {
                                subItem.type = 'user';
                                subItem.avatars = avatar;
                                subItem.Id = cellItem.value;
                                subItem.Name = uiHelper.extractUserName(
                                    cellItem.text
                                );
                            }
                            subItem.content = cellItem.text;
                            if (
                                showColumn == undefined ||
                                (showColumn && showColumn - 1 >= colIndex)
                            ) {
                                item.subInfo.push(subItem);
                            }
                        }
                        colIndex = colIndex + 1;
                    }
                });
                if (item.mainInfo.title === undefined) {
                    let firstSub = item.subInfo.shift();
                    item.mainInfo.title = uiHelper.extractUserName(
                        firstSub.content
                    );
                    if (firstSub.ControlType == 'SingleStaffInput') {
                        item.mainInfo.Name =
                            uiHelper.extractUserName(firstSub.content) ||
                            '----';
                        item.mainInfo.showMedia = true;
                        if (firstSub.avatars) {
                            item.mainInfo.avatars = firstSub.avatars;
                        } else {
                            item.mainInfo.mediaType = 'default';
                        }
                    }
                }
                datalist.push(Object.assign(row, item));
            });
        }
        return datalist;
    }
    render() {
        const datalist = this.getBasicComponentNeededDataList();
        const onLoading =
            !this.props.cmp_id || !this.props.sub_cmps || this.props.isFetching;
        return (
            <div ref="formlist">
                {this.props.expandRegion ? (
                    <ComponentHolder
                        componentName={this.props.expandRegion.view_path}
                        {...this.props}
                    />
                ) : null}
                <TableList
                    standardFormatedRows={datalist}
                    onTouchTap={this.tableItemClick}
                    containerHeight={this.props.emptyContainerHeight}
                    getEmptyHeight={this.props.getEmptyHeight}
                    num={1}
                    selectIds={this.props.selectIds}
                    showChecked={this.props.showChecked || false}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/FormList/FormList.js